export default __webpack_public_path__ + "static/media/tom.34407ab8.png";